<template>
	<div>
		<el-card class="box-card">
			<el-col :span="4" style="margin-left: 10px;margin-bottom: 20px;">
				<el-button type="primary" icon="el-icon-plus" @click="storeAdd">绑定店铺</el-button>
			</el-col>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="店铺网址:">
								<el-link type="primary" :href="props.row.url" target="_blank">{{props.row.url}}
								</el-link>
							</el-form-item>
							<el-form-item label="店铺截图:">
								<el-image v-if="props.row.img" style="width: 40px; height: 40px" :src="props.row.img"
									fit="fill" :preview-src-list="[props.row.img]">
								</el-image>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="店铺名"> </el-table-column>
				<el-table-column prop="account" label="店铺账号"> </el-table-column>
				<el-table-column prop="platform_init" label="平台"> </el-table-column>
				<el-table-column prop="country_init" label="国家地区"> </el-table-column>
				<el-table-column prop="wx" label="负责人微信"> </el-table-column>
				<el-table-column prop="mobile" label="负责人电话"> </el-table-column>
				<el-table-column prop="create_time" label="绑定日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="审核状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
		<!-- 添加店铺模态框 -->
		<el-dialog title="店铺设置" :visible.sync="is_show_add" width="40%">
			<el-form label-position="right" label-width="100px">
				<el-form-item label="平台:">
					<el-col :span="10">
						<el-select v-model="add_data.platform" placeholder="请选择">
							<el-option v-for="item in platform_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="国家地区:">
					<el-col :span="10">
						<el-select v-model="add_data.country" placeholder="请选择">
							<el-option v-for="item in country_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="店铺名:">
					<el-col :span="12">
						<el-input v-model="add_data.name" placeholder="请输入"></el-input>
						<span style="color: red;">提示：多国家同店名重复的，请在店名后面加编号</span>
					</el-col>
				</el-form-item>
				<el-form-item label="店铺账号:">
					<el-col :span="12">
						<el-input v-model="add_data.account" placeholder="请输入"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="负责人微信:">
					<el-col :span="12">
						<el-input v-model="add_data.wx" placeholder="请输入"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="负责人电话:">
					<el-col :span="12">
						<el-input v-model="add_data.mobile" placeholder="请输入"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="店铺网址:">
					<el-col :span="12">
						<el-input v-model="add_data.url" placeholder="请输入"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="店铺截图:">
					<el-col :span="12">
						<Img @imgList="imgsImg" :img_num="1" :img_edit="add_data.img"></Img>
						<el-button type="text" @click="slsm">示例说明</el-button>
					</el-col>
				</el-form-item>
				<el-row>
					<el-col :span="24" style="text-align: center;">
						<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="storeAdd2">提交绑定</el-button>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
		<!-- 示例图片 -->
		<el-dialog title="示例图片" :visible.sync="is_show_slsm" width="40%">
			<el-image :src="slsm_url" fit="fill"></el-image>
		</el-dialog>
	</div>
</template>

<script>
	import {
		storeList,
		getPc,
		storeAdd
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	export default {
		components: {
			Pagination,
			Img
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_add: false,
				add_data: {},
				country_list: [],
				platform_list: [],
				is_show_slsm: false,
				slsm_url:'',
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.resetAddData()
			this.getPc();
			this.getList()
		},
		methods: {
			resetAddData() {
				this.add_data = {
					'platform':'',
					'country':'',
					'name':'',
					'account':'',
					'wx':'',
					'mobile':'',
					'url':'',
					'img': [],
				}
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
					},
				}
			},
			getPc() {
				getPc(Qs.stringify()).then(response => {
					this.country_list = response.result.country;
					this.platform_list = response.result.platform;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				storeList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			storeAdd() {
				this.resetAddData()
				this.is_show_add = true;
			},
			storeAdd2(){
				// if(this.add_data.img.length == 0){
				// 	this.add_data.img = '';
				// }
				this.$store.commit('setAjaxLoading', true);
				storeAdd(Qs.stringify(this.add_data)).then(response => {
					this.$message({
						showClose: true,
						message: '提交成功',
						type: 'success'
					});
					this.is_show_add = false;
					this.getList();
				})
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.add_data.img = e;
			},
			slsm() {
				if(this.add_data.platform == 1){
					this.slsm_url = '/lazada.png';
				}else if(this.add_data.platform == 2){
					this.slsm_url = '/shopee.png';
				}else{
					this.$message({
						showClose: true,
						message: '请先选择平台',
						type: 'error'
					});
					return false;
				}
				this.is_show_slsm = true;
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
